import React from "react";
import { WhatsApp } from "./Icons";
import { useReveal } from "../hooks/useReveal";
import { useClinicPicker } from "./ClinicPicker";
import { SAME_PRICE_NOTE } from "../data/clinics";

const WHATSAPP_MESSAGE = (clinic) =>
  `Hi, saya tertarik dengan promo October Privileges 2026 di ${clinic.name}. Bisa info lebih lanjut?`;

const LEFT_COLUMN = [
  {
    name: "BOTOX",
    items: [
      { treatment: "Full Face Botox / 100IU", originalPrice: "3,000K", price: "2,550K" },
      { treatment: "Forehead", originalPrice: "1,500K", price: "1,200K" },
      { treatment: "Upper Face", originalPrice: "1,650K", price: "1,500K" },
      { treatment: "Crossfit (Bunny Lines)", originalPrice: "1,000K", price: "600K" },
      { treatment: "Masseter", originalPrice: "2,200K", price: "1,800K" },
      { treatment: "Lip Flip", originalPrice: "800K", price: "500K" },
      { treatment: "Nefertiti Lift", originalPrice: "1,500K", price: "1,250K" },
      { treatment: "Neck Nefertiti", originalPrice: "3,500K", price: "2,750K" },
      { treatment: "Shoulder Slimming", originalPrice: "3,500K", price: "3,000K" },
      { treatment: "Armpit Sweating", originalPrice: "3,500K", price: "3,000K" },
      { treatment: "Wet Hands", originalPrice: "3,500K", price: "3,000K" },
      { treatment: "USA Allergan Botox / 100IU", originalPrice: "8,000K", price: "5,500K" },
    ],
  },
  {
    name: "KOREAN FILLER",
    note: "Price per 1ml.",
    items: [
      { treatment: "Lip Filler", originalPrice: "3,000K", price: "1,500K" },
      { treatment: "Chin Filler", originalPrice: "3,000K", price: "1,500K" },
      { treatment: "Jawline Filler", originalPrice: "3,000K", price: "1,500K" },
      { treatment: "Smile Line Filler", originalPrice: "3,000K", price: "1,500K" },
      { treatment: "Cheekbones Filler", originalPrice: "3,000K", price: "1,500K" },
    ],
  },
  {
    name: "EUROPEAN FILLER",
    note: "Price per 1ml.",
    items: [
      { treatment: "Lip Filler", originalPrice: "4,500K", price: "2,250K" },
      { treatment: "Chin Filler", originalPrice: "4,500K", price: "2,250K" },
      { treatment: "Jawline Filler", originalPrice: "4,500K", price: "2,250K" },
      { treatment: "Smile Line Filler", originalPrice: "4,500K", price: "2,250K" },
      { treatment: "Cheekbones Filler", originalPrice: "4,500K", price: "2,250K" },
    ],
  },
  {
    name: "BODY FILLER",
    note: "Body Filler 150cc. Doctor assessment required.",
    items: [
      { treatment: "Body Filler 150cc", originalPrice: "25,000K", price: "16,000K" },
    ],
  },
  {
    name: "THREADLIFT TREATMENT",
    note: "Price is per thread. Number of threads depends on individual assessment.",
    items: [
      { treatment: "Cheek V-Shape Regular", originalPrice: "800K", price: "600K" },
      { treatment: "Cheek V-Shape Premium", originalPrice: "1,500K", price: "1,000K" },
      { treatment: "Foxy Eye", originalPrice: "1,000K", price: "800K" },
      { treatment: "Double Chin Regular", originalPrice: "800K", price: "600K" },
      { treatment: "Double Chin Premium", originalPrice: "1,500K", price: "1,000K" },
    ],
  },
  {
    name: "NOSE THREAD TREATMENT",
    note: "Bridge & nostril thread priced per thread. Korean & Turkish Nose are full packages.",
    items: [
      { treatment: "Nose Bridge Thread", originalPrice: "600K", price: "500K" },
      { treatment: "Nostril Thread", originalPrice: "600K", price: "500K" },
      { treatment: "Korean Nose / 10 Thread", originalPrice: "5,000K", price: "3,500K" },
      { treatment: "Turkish Nose / 15 Thread", originalPrice: "7,000K", price: "5,000K" },
    ],
  },
  {
    name: "SKIN BOOSTER TREATMENT",
    items: [
      { treatment: "Korean Skin Booster Hydration", originalPrice: "600K", price: "500K" },
      { treatment: "Korean Skin Booster 2 Elements", originalPrice: "900K", price: "750K" },
      { treatment: "Korean Skin Booster 5 Elements", originalPrice: "1,000K", price: "800K" },
      { treatment: "Korean Skin Booster 7 Elements", price: "1,500K" },
      { treatment: "PDRN DNA Salmon", price: "1,500K" },
      { treatment: "PN Booster", originalPrice: "2,500K", price: "1,500K" },
      { treatment: "Collagen Stimulator", originalPrice: "3,000K", price: "2,500K" },
      { treatment: "Exosome", originalPrice: "4,500K", price: "3,000K" },
      { treatment: "Dermaflek", originalPrice: "1,000K", price: "800K" },
    ],
  },
  {
    name: "PREMIUM SKIN BOOSTER",
    items: [
      { treatment: "NCTF", originalPrice: "2,500K", price: "1,500K" },
      { treatment: "Yaqoot Sapphire", originalPrice: "4,000K", price: "2,500K" },
      { treatment: "NCTF + Yaqoot", originalPrice: "4,000K", price: "3,000K" },
      { treatment: "NCTF + PN Booster", originalPrice: "4,000K", price: "3,000K" },
      { treatment: "Iluma Skin Booster", originalPrice: "3,500K", price: "2,500K" },
      { treatment: "NAD+ Skin Booster", originalPrice: "3,500K", price: "2,500K" },
      { treatment: "Cell Booster", originalPrice: "3,500K", price: "2,500K" },
      { treatment: "ZQ II", originalPrice: "6,000K", price: "3,000K" },
    ],
  },
  {
    name: "PRP REGENERATIVE",
    items: [
      { treatment: "Face PRP", originalPrice: "1,000K", price: "800K" },
      { treatment: "Hair PRP", originalPrice: "1,500K", price: "1,000K" },
    ],
  },
  {
    name: "MESSO TREATMENT",
    items: [
      { treatment: "Face Messo / cc", originalPrice: "300K", price: "250K / cc" },
      { treatment: "Body Messo / 10cc", originalPrice: "1,500K", price: "800K / 10cc" },
      { treatment: "RF Add-On", originalPrice: "250K", price: "150K" },
    ],
  },
];

const RIGHT_COLUMN = [
  {
    name: "DPL HAIR REMOVAL",
    items: [
      { treatment: "Moustache", originalPrice: "300K", price: "200K" },
      { treatment: "Back of Hands", originalPrice: "300K", price: "200K" },
      { treatment: "Bikini Line", originalPrice: "450K", price: "300K" },
      { treatment: "Arms Area", originalPrice: "450K", price: "400K" },
      { treatment: "Beard", originalPrice: "500K", price: "350K" },
      { treatment: "Upper Leg", originalPrice: "550K", price: "400K" },
      { treatment: "Lower Leg", originalPrice: "450K", price: "350K" },
      { treatment: "Full Leg", originalPrice: "750K", price: "500K" },
      { treatment: "Chest", originalPrice: "1,000K", price: "750K" },
      { treatment: "Brazilian / Buttocks", originalPrice: "550K", price: "300K" },
    ],
  },
  {
    name: "DPL SKIN TREATMENT",
    items: [
      { treatment: "DPL Acne", originalPrice: "750K", price: "500K" },
      { treatment: "DPL Rejuvenation", originalPrice: "1,000K", price: "750K" },
    ],
  },
  {
    name: "PICO LASER TREATMENT",
    items: [
      { treatment: "Blackdoll", originalPrice: "550K", price: "400K" },
      { treatment: "Lip Laser", originalPrice: "400K", price: "250K" },
      { treatment: "Armpit Brightening", originalPrice: "350K", price: "300K" },
      { treatment: "Face Brightening", originalPrice: "750K", price: "500K" },
      { treatment: "Tattoo Removal / cm", originalPrice: "65K", price: "50K / cm" },
      { treatment: "Eye Brow Removal", originalPrice: "550K", price: "300K" },
      { treatment: "Back Body Brightening", originalPrice: "1,000K", price: "750K" },
      { treatment: "Scar Laser", originalPrice: "850K", price: "500K" },
    ],
  },
  {
    name: "CO2 FRACTIONAL",
    note: "Melasma & stretchmark pricing based on doctor assessment / size.",
    items: [
      { treatment: "Scar Removal (S)", originalPrice: "600K", price: "500K" },
      { treatment: "Scar Removal (M)", originalPrice: "750K", price: "600K" },
      { treatment: "Scar Removal Full Face", originalPrice: "1,000K", price: "750K" },
      { treatment: "Rejuve", price: "500K" },
      { treatment: "Under Eye", originalPrice: "750K", price: "500K" },
      { treatment: "Melasma", originalPrice: "750K", price: "400K" },
      { treatment: "Cauter / Spot", price: "100K / spot" },
      { treatment: "Stretchmark", originalPrice: "1,200K", price: "750K" },
      { treatment: "Blackspot", originalPrice: "800K", price: "500K" },
    ],
  },
  {
    name: "FACIAL TREATMENT",
    items: [
      { treatment: "Radiant Glow", price: "150K" },
      { treatment: "Hollywood Peel", price: "200K" },
      { treatment: "Anti Aging", price: "225K" },
      { treatment: "DNA Salmon", price: "250K" },
      { treatment: "Hydra Full", price: "285K" },
    ],
  },
  {
    name: "ACNE SCAR TREATMENT",
    items: [
      { treatment: "Acne Injection / Spot", originalPrice: "35K", price: "25K / spot" },
      { treatment: "Subcision Acne Scar", price: "500K" },
      { treatment: "Subcision Acne Scar + DNA Salmon", originalPrice: "1,000K", price: "800K" },
      { treatment: "Subcision Acne Scar + Premium DNA Salmon", price: "1,500K" },
      { treatment: "Subcision Acne Scar + Dermapen DNA Salmon", originalPrice: "1,750K", price: "1,500K" },
    ],
  },
  {
    name: "KELOID TREATMENT",
    note: "Price may vary depending on size & assessment.",
    items: [
      { treatment: "Keloid Injection Small", originalPrice: "550K", price: "300K" },
      { treatment: "Keloid Injection Medium", originalPrice: "600K", price: "500K" },
      { treatment: "Keloid Injection Large", originalPrice: "850K", price: "750K" },
    ],
  },
  {
    name: "PEELING TREATMENT",
    items: [
      { treatment: "Face Acne", originalPrice: "500K", price: "300K" },
      { treatment: "Back Body Acne", originalPrice: "1,000K", price: "750K" },
      { treatment: "Face Brightening", originalPrice: "750K", price: "500K" },
      { treatment: "Premium Face Brightening", price: "1,000K" },
      { treatment: "Fold Brightening Peel / Area", originalPrice: "1,000K", price: "500K" },
    ],
  },
  {
    name: "BRIGHTENING INFUSION",
    items: [
      { treatment: "Super Bright Infusion", originalPrice: "550K", price: "500K" },
      { treatment: "Porcelain Infusion", originalPrice: "1,000K", price: "750K" },
    ],
  },
  {
    name: "IV DRIP & WELLNESS",
    note: "Performed by our experienced doctors. Medical Hydration Support requires doctor assessment.",
    items: [
      { treatment: "Vitamin C Infusion", originalPrice: "300K", price: "200K" },
      { treatment: "Toxic Belly I", originalPrice: "1,000K", price: "750K" },
      { treatment: "Immune Support Infusion", originalPrice: "750K", price: "500K" },
      { treatment: "Post-Party Recovery", originalPrice: "1,250K", price: "1,000K" },
      { treatment: "Medical Hydration Support", originalPrice: "750K", price: "500K" },
      { treatment: "Hydration Infusion", originalPrice: "600K", price: "400K" },
    ],
  },
];

function CategoryBlock({ category }) {
  return (
    <div className="mb-6">
      <div className="flex items-center gap-4 mb-3">
        <h3 className="text-sm font-bold text-white uppercase tracking-wider whitespace-nowrap">
          {category.name}
        </h3>
        <div className="flex-1 h-px bg-gradient-to-r from-[#D4AF37]/25 to-transparent" />
      </div>
      <div className="space-y-2">
        {category.items.map((item, i) => (
          <div key={`${item.treatment}-${i}`} className="flex items-baseline justify-between gap-3 group">
            <span className="text-sm text-white/40 group-hover:text-white/60 transition-colors">
              {item.treatment}
            </span>
            <span className="text-sm font-semibold tabular-nums whitespace-nowrap transition-colors">
              {item.originalPrice && (
                <span className="text-white/30 line-through mr-2">{item.originalPrice}</span>
              )}
              <span className="text-white/70 group-hover:text-[#D4AF37]">{item.price}</span>
            </span>
          </div>
        ))}
      </div>
      {category.note && (
        <p className="text-[11px] text-[#D4AF37]/60 italic mt-3">{category.note}</p>
      )}
    </div>
  );
}

export default function PromoTreatmentList() {
  const [headerRef, headerVisible] = useReveal();
  const [contentRef, contentVisible] = useReveal();
  const openPicker = useClinicPicker();

  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-[#070E1A] via-[#0C1829] to-[#0A1522]">
      {/* Glowing accents */}
      <div className="absolute top-0 right-1/3 w-[700px] h-[300px] bg-[#D4AF37]/[0.04] rounded-full blur-[150px] animate-pulse-soft" />
      <div className="absolute bottom-0 left-[10%] w-[300px] h-[200px] bg-[#D4AF37]/[0.03] rounded-full blur-[100px]" />

      <div className="container-wide mx-auto relative z-10 px-5 sm:px-8 lg:px-12 py-20 md:py-28">
        {/* Header */}
        <div
          ref={headerRef}
          className={`reveal ${headerVisible ? "visible" : ""} text-center mb-14`}
        >
          <div className="inline-flex items-center gap-2 bg-[#D4AF37]/10 border border-[#D4AF37]/20 rounded-full px-4 py-1.5 mb-6 backdrop-blur-sm">
            <span className="relative flex h-2 w-2">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-[#D4AF37] opacity-75" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-[#D4AF37]" />
            </span>
            <span className="text-[11px] font-bold uppercase tracking-[0.15em] text-[#D4AF37]">
              October 2026
            </span>
          </div>

          <h2 className="font-display text-display-xl text-white mb-1 tracking-wide"
              style={{ textShadow: "0 0 60px rgba(212,175,55,0.12)" }}>
            OCTOBER PRIVILEGES
          </h2>
          <p className="text-xl text-[#D4AF37]/40 italic font-display">beauty investment for a more confident you</p>

          {/* Decorative line */}
          <div className="flex items-center justify-center gap-3 mt-6">
            <div className="w-12 h-px bg-gradient-to-r from-transparent to-[#D4AF37]/30" />
            <div className="w-1.5 h-1.5 rounded-full bg-[#D4AF37]/40" />
            <div className="w-12 h-px bg-gradient-to-l from-transparent to-[#D4AF37]/30" />
          </div>
        </div>

        {/* Two-column price list */}
        <div
          ref={contentRef}
          className={`reveal ${contentVisible ? "visible" : ""} max-w-5xl mx-auto`}
        >
          <div className="rounded-3xl border border-white/[0.06] bg-white/[0.02] backdrop-blur-sm p-6 sm:p-10 lg:p-12
                          shadow-[0_0_80px_-20px_rgba(212,175,55,0.08)]">
            <div className="grid md:grid-cols-2 gap-x-12 lg:gap-x-16 gap-y-0">
              <div>
                {LEFT_COLUMN.map((cat) => (
                  <CategoryBlock key={cat.name} category={cat} />
                ))}
              </div>
              <div>
                {RIGHT_COLUMN.map((cat) => (
                  <CategoryBlock key={cat.name} category={cat} />
                ))}
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="text-center mt-12">
          <p className="text-xs text-white/25 mb-6">Limited slots &middot; Valid 1&ndash;31 October 2026 &middot; {SAME_PRICE_NOTE} &middot; All prices are listed in IDR (Indonesian Rupiah)</p>
          <button
            onClick={() => openPicker(WHATSAPP_MESSAGE)}
            className="group btn bg-[#25D366] text-white px-10 py-4 text-sm font-bold rounded-full uppercase tracking-wider
                       hover:bg-[#20bd5a] hover:shadow-[0_0_30px_rgba(37,211,102,0.3)] active:scale-[0.98]
                       transition-all duration-300 shadow-lg shadow-[#25D366]/25"
          >
            <WhatsApp size={20} />
            Claim October Privilege
          </button>
        </div>
      </div>
    </section>
  );
}
